var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    _vm._l(_vm.pageContentIds, function (pageContentId) {
      return _c("PageEditorContentNavContentItem", {
        key: pageContentId,
        attrs: { "page-content-id": pageContentId },
      })
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }